import { View } from "@pimo/pimo-app-builder";
import { DragAndDropLayout, PMTitleCard } from "@pimo/pimo-components";
import { getLocalizedMessage } from "@pimo/pimo-l10n";
import { PROJECT_NAMES } from "vmd-types";

import { TestAppState } from "../../../app";
import { theme } from "../../../theme";
import { formatDate } from "../../../utils/format-date";

/**
 * Adds the overview title card and the DC Business Apps overview title card, in
 * that order (#2222).
 */
export function addTitleCards(view: View<TestAppState, DragAndDropLayout>) {
  const titleComponent = view.addComponent({
    component: PMTitleCard,
    layoutProps: {
      componentId: "titleComponent",
      labels: ["title"],
      title: "",
      description: "",
    },
  });

  titleComponent.mapLayoutProps(({ language }) => ({
    componentId: "titleComponent",
    labels: ["title"],
    title:
      getLocalizedMessage(language || "en", "overviewPlugin.title") || "Title",
    description:
      getLocalizedMessage(
        language || "en",
        "overviewPlugin.titleDescription"
      ) || "this is the Title card.",
  }));

  titleComponent.mapState(({ overview, settings, language }) => {
    return {
      title: `${
        PROJECT_NAMES.find(
          (name) => name.single === settings?.configuration?.projectName
        )?.plural ?? getLocalizedMessage(language || "en", "project")
      } ${getLocalizedMessage(language || "en", "overview")} ${
        settings?.configuration?.programName
          ? `- ${settings?.configuration?.programName}`
          : ""
      }`,
      badgeConfigs: overview?._calculated?.lastReportingEndDate
        ? [
            {
              label: `${
                getLocalizedMessage(language || "en", "AsOf") || "As of"
              }: ${formatDate(overview?._calculated?.lastReportingEndDate, language)}`,
              backgroundColor: theme.palette.secondary.light,
              color: theme.palette.primary.main,
            },
          ]
        : [],
    };
  });

  const itSystemsOverviewTitleComponent = view.addComponent({
    component: PMTitleCard,
    layoutProps: {
      componentId: "itSystemsOverviewTitleComponent",
      labels: ["title", "itSystemsOverview"],
      title: "",
      description: "",
    },
  });

  itSystemsOverviewTitleComponent.mapLayoutProps(({ language }) => ({
    componentId: "itSystemsOverviewTitleComponent",
    labels: ["title", "itSystemsOverview"],
    title:
      getLocalizedMessage(
        language || "en",
        "overviewPlugin.itSystemsOverviewTitle"
      ) || "Overview",
    description:
      getLocalizedMessage(
        language || "en",
        "overviewPlugin.itSystemsOverviewDescription"
      ) || "Shows all DC Business Apps across all projects.",
  }));

  itSystemsOverviewTitleComponent.mapState(({ overview, language }) => ({
    title:
      getLocalizedMessage(
        language || "en",
        "overviewPlugin.itSystemsOverviewTitle"
      ) || "Overview",
    badgeConfigs: overview?._calculated?.lastReportingEndDate
      ? [
          {
            label: `${
              getLocalizedMessage(language || "en", "AsOf") || "As of"
            }: ${formatDate(overview?._calculated?.lastReportingEndDate, language)}`,
            backgroundColor: theme.palette.secondary.light,
            color: theme.palette.primary.main,
          },
        ]
      : [],
  }));
}
